<template>
  <div class="FunctionalDetails">
    <v-row>
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.FunctionalDetails.lblKarKard") }}:<span
          class="text-value px-1"
          >{{ ConvertMinuteToHour(details.WWORK) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.FunctionalDetails.lblShabKari") }}:<span
          class="text-value px-1"
          >{{ ConvertMinuteToHour(details.NIGHTWORK) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblMeghdartakhireMojaz")
        }}:<span class="text-value px-1">{{
          ConvertMinuteToHour(details.LATEPERMAMOUNT)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblTedadeTakhireMojaz")
        }}:<span class="text-value px-1">{{
          details.LATEPERMCOUNT
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblMeghdarTajileMojaz")
        }}:<span class="text-value px-1">{{
          ConvertMinuteToHour(details.EARLYPERMAMOUNT)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblTedadeTajileMojaz")
        }}:<span class="text-value px-1">{{
          details.EARLYPERMCOUNT
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblTedadeRozeHozor")
        }}:<span class="text-value px-1">{{ details.DAYSPRESENT }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.FunctionalDetails.lblTedadRozeKarkard")
        }}:<span class="text-value px-1">{{ details.DAYSWORKED }}</span></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.FunctionalDetails.lblJamekarKard") }}:<span
          class="text-value px-1"
          >{{ ConvertMinuteToHour(details.WORKTOTAL) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.FunctionalDetails.lblDaysBaHoghogh") }}:<span
          class="text-value px-1"
          >{{ details.PAYINGDAYS }}</span
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["details"],
};
</script>

<style>
</style>